import { PLAYER_ROLES, PLAYER_ROLES_WITH_STRADDLES, type PlayerPosition } from '@acepoker/contract/acepoker'
import type { PreviewTablePlayer } from './../types'
import type { Drill } from '@acepoker/contract'

type Roles = Record<number, readonly PlayerPosition[]>

export function generateFakeNlhePlayers(
  drill: Pick<Drill, "gaming_configuration" | "max_players">,
): PreviewTablePlayer[] {
  const maxPlayers = drill.max_players ?? 0;

  const roles: readonly PlayerPosition[] =
    drill.gaming_configuration.blinds.length === 3
      ? (PLAYER_ROLES_WITH_STRADDLES as Roles)[maxPlayers] ?? []
      : (PLAYER_ROLES as Roles)[maxPlayers] ?? [];

  return roles.map(
    (position: PlayerPosition, i: number): PreviewTablePlayer => ({
      position,
      seat_no: i,
      stack: 0,
    }),
  );
}
